import { Component, OnInit, ViewChild, Renderer2, AfterViewInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { UsuarioConLlamadas, Llamada, Cobro } from './llamada';
import * as moment from 'moment';
import { DataTableDirective } from 'angular-datatables';
import { InformesService } from 'app/services/informes.service'
import { MatDialog } from '@angular/material';
import { LlamadasBitacoraComponent } from 'app/modals/cartera/llamadas-bitacora/llamadas-bitacora.component';
import { HistorialCobrosComponent } from 'app/modals/cartera/historial-cobros/historial-cobros.component';

@Component({
  selector: 'app-gestionar-cartera',
  templateUrl: './gestionar-cartera.component.html',
  styleUrls: ['./gestionar-cartera.component.scss']
})
export class GestionarCarteraComponent implements OnInit,AfterViewInit {
  public informe:string;
  public form:FormGroup;
  public dtOptions;
  public dtTrigger:Subject<void>;
  public llamadas:Array<UsuarioConLlamadas>;
  @ViewChild(DataTableDirective, {static: false}) tabla: DataTableDirective;
  constructor(private _informes:InformesService, private _renderer:Renderer2,private _dialog:MatDialog) {
    this.llamadas = [];
    this.dtTrigger = new Subject();
    this.dtOptions = {
      responsive: {
        details: {
            type: 'column',
            target: -1
        }
      },
      autoWidth: false,
      order: [1, 'desc'],
      language: {
        sProcessing: "Procesando...",
        sLengthMenu: "Mostrar _MENU_ registros",
        sZeroRecords: "No se encontraron resultados",
        sEmptyTable: "Ningún dato disponible en esta tabla",
        sInfo: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
        sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
        sInfoPostFix: "",
        sSearch: "Buscar:",
        sUrl: "",
        sInfoThousands: ",",
        sLoadingRecords: "Cargando...",
        oPaginate: {
          sFirst: "Primero",
          sLast: "Último",
          sNext: "Siguiente",
          sPrevious: "Anterior"
        },
        select: {
          rows: {
            _: "%d Filas seleccionadas",
            0: "Da clic en una fila para seleccionarla",
            1: "1 Fila seleccionada"
          }
        }
      },
      columns: [
        {
          title:'Usuario',
          data:'usuario'
        },
        {
          title:'N Llamadas',
          render:(data, type, row, meta)=>{
            return `<a row="${meta.row}" llamadasInforme="true" key="llamadas" >${data}</a>`;
          }
        },
        {
          title:'C Agendados',
          render:(data, type, row, meta) =>{
            return `<a row="${meta.row}" agendadas="true" key="agendadas" >${data}</a>`;
          }
        },
        {
          title:'no contestadas',
          render:(data, type, row, meta)=>{
            return `<a row="${meta.row}" llamadasInforme="true" key="noContestadas" >${data}</a>`;
          }
        },
        {
          title:'contestadas',
          render:(data, type, row, meta)=>{
            return `<a row="${meta.row}" llamadasInforme="true" key="contestadas" >${data}</a>`;
          }
        },
        {
          title:'pago',
          render:(data, type, row, meta)=>{
            return `<a row="${meta.row}" llamadasInforme="true" key="yaPagas" >${data}</a>`;
          }
        },
        {
          title:'Paga Luego',
          render:(data, type, row, meta)=>{
            return `<a row="${meta.row}" llamadasInforme="true" key="pagaLuego" >${data}</a>`;
          }
        },
        {
          title:'No puede Pagar',
          render:(data, type, row, meta)=>{
            return `<a row="${meta.row}" llamadasInforme="true" key="noPuedePagar" >${data}</a>`;
          }
        },
        {
          title:'Abona a factura',
          render:(data, type, row, meta)=>{
            return `<a row="${meta.row}" llamadasInforme="true" key="abonoAFactura" >${data}</a>`;
          }
        },
        {
          title:'llamadas Empresa',
          render:(data, type, row, meta)=>{
            return `<a row="${meta.row}" llamadasInforme="true" key="llamadasEmpresa" >${data}</a>`;
          }
        },
        {
          title:'llamadas Cliente',
          render:(data, type, row, meta)=>{
            return `<a row="${meta.row}" llamadasInforme="true" key="llamadasCliente" >${data}</a>`;
          }
        },
        {
          className: 'control',
          orderable: false,
          targets:   -1
        }
      ]
    }
  }
  ngAfterViewInit(): void {
    this._renderer.listen('document','click',(e)=>{
      if(e.target.hasAttribute('llamadasInforme')){
        let row = +e.target.getAttribute('row');
        let key = e.target.getAttribute('key');

        let llamadas:Array<Llamada> = this.llamadas[row][key];
        this._dialog.open(LlamadasBitacoraComponent,{
          data:{
            llamadas
          }
        })
      }
      if(e.target.hasAttribute('agendadas')){
        let row = +e.target.getAttribute('row');
        let key = e.target.getAttribute('key');

        let cobros:Array<Cobro> = this.llamadas[row][key];
        this._dialog.open(HistorialCobrosComponent,{
          data:{
            cobros
          }
        })
      }
    });
  }

  ngOnInit() {
    this.form = this.createForm();
  }
  public createForm ():FormGroup{
    return new FormGroup({
      fechaInicio:new FormControl(moment()),
      fechaFinal:new FormControl(moment()),
    })
  }

  public buscar(){
    let body;
    console.log("hola")
    body = {...this.form.value};
    body.fechaFinal =  moment(body.fechaFinal).format("YYYY-MM-DD");
    body.fechaInicio = moment(body.fechaInicio).format("YYYY-MM-DD");
    this._informes.informeGestionDeCartera(body).subscribe(llamadas=>{
      this.llamadas = llamadas;
      if(this.tabla.dtInstance !== undefined){
        this.renderer();
        return;
      }
      this.dtTrigger.next();
    })
  }

  public renderer(){
    this.tabla.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
}
